import React, { useState } from "react";
import RecurringTasksList from "./components/RecurringTasksList";
import TemplateTaskEditor from "./components/TemplateTaskEditor";
import './taskedit.css';

const EditRecurringTasksPage: React.FC = () => {
    const [templateTaskId, setTemplateTaskId] = useState<number | undefined>();

    const handleEditTask = (taskId: number) => {
        setTemplateTaskId(taskId);
    };

    const handleBackToList = () => {
        setTemplateTaskId(undefined);
    };

    return (
        <div className="common_card">
            {!templateTaskId ? (
                <RecurringTasksList onEditTask={handleEditTask} />
            ) : (
                <TemplateTaskEditor
                    templateTaskId={templateTaskId}
                    onBack={handleBackToList}
                />
            )}
        </div>
    );
};

export default EditRecurringTasksPage;